export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.icon)+'"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" preserveAspectRatio="xMidYMin slice" width="100%" style="padding-bottom: 100%; height: 1px; overflow: visible"> <!-- padding-bottom: 100% * height/width --> <path class="'+(props.themeStyles.fullScreenSvgFill)+'" fill-rule="evenodd" d="M2 10H0v4h4v-2H2v-2zM0 1v3h2V2h2V0H0v1zm14-1h-4v2h2v2h2V0zm-2 12h-2v2h4v-4h-2v2z"/> </svg></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/controls/full-screen/templates/enterFullScreenIcon.dot
// module id = 240
// module chunks = 0 1 2 3 4